import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import VueToast from 'vue-toast-notification';
import VueLazyload from '@jambonn/vue-lazyload'
import 'vue-toast-notification/dist/theme-sugar.css';

const app = createApp(App)
    .use(store)
    .use(router)
    .use(VueToast)
    .use(VueLazyload, {
        lazyComponent: true,
        preLoad: 1,
    });

app.config.globalProperties.$filters = {
    formatDate(v: string) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            minute: 'numeric',
            second: 'numeric',
            hour: 'numeric',
            hour24: true
        };
        const currentDate = this.convertDateForIos(v);
        return currentDate.toLocaleDateString("en-GB", options);
    },
    convertDateForIos(v: any) {
        let result = null;
        try {
            const arr = v.toString().split(/[- :]/);
            result = new Date(Date.UTC(arr[2], arr[1] - 1, arr[0], arr[3], arr[4], arr[5]));
        } catch (e) {
            result = new Date(v);
        }
        return result;
    },
    getDate: function (v: any) {
        return this.convertDateForIos(v);
    },
    formatNumber(val) {
        return parseFloat(val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    formatThousandNumber(val) {
        return Number(val).toLocaleString(undefined, { minimumFractionDigits: 2 });
    }
}

app.mount('#app')
